import { request } from './request';

// 基金项目
export interface FundItem {
  id: number;
  name: string;
  description: string;
  label: string;
  url: string;
}

// 投融资服务信息接口响应类型
export interface FinancingInfo {
  'self-owned': FundItem[];
  'self-incubation': FundItem[];
  'cooperative-investment': FundItem[];
}

// 通用响应类型
export interface ApiResponse<T = any> {
  code: number;
  data: T;
  msg: string;
  total?: number;
}

/**
 * 获取投融资服务信息
 */
export const getFinancingInfo = () => {
  return request.get('/financing/info');
};
